export const md = `
# markdown 教程

## 标题
\`\`\`
# 一级标题
## 二级标题
### 三级标题
\`\`\`

效果：
# 一级标题
## 二级标题
### 三级标题

## 文本样式
可以在评论字段和 .md 文件中以粗体、斜体、删除线、下标或上标文本表示强调。

Style|语法 | 示例 | 输出 |
--|--|--|--|
加粗|	** ** 或 __ __	|	\`**This is bold text**\`|**这是粗体文本**|
斜体|	* * 或 _ _ |	\`_This text is italicized_\`	|_这是斜体文本_|
删除线|	~~ ~~	|\`~~This was mistaken text~~\`	|~~这是错误文本~~|
粗体和嵌入的斜体|	** ** 和 _ _|\`**This text is _extremely_ important**\`|**此文本_非常_重要**|
全部粗体和斜体|	*** ***	|\`***All this text is important***\`|***所有这些文本都很重要***|
下标	|<sub> </sub>|\`This is a <sub>subscript</sub> text\`|这是<sub>下标</sub> 文本|
上标	|<sup> </sup>|	\`This is a <sup>superscript</sup> text\`	|这是<sup>上标</sup>文本|
下划线	|<ins> </ins>	|	\`This is an <ins>underlined</ins> text\`	|此文本带<ins>下划线</ins>|

## 引用文本

\`\`\`
Text that is not a quote

> Text that is a quote
\`\`\`

效果：
Text that is not a quote

> Text that is a quote

## 引用代码

\`\`\`
Use \`git status\` to list all new or modified files that haven't yet been committed.
\`\`\`

效果：
Use \`git status\` to list all new or modified files that haven't yet been committed.

## 链接

\`\`\`
[百度](https://www.baidu.com)
\`\`\`

效果：
[百度](https://www.baidu.com)

## 图片

\`\`\`
![图片加载失败的文案](http://placehold.it/150x100 "悬浮提示文案")
\`\`\`

效果：
选择一个正确的图片地址即可正常访问, 或者使用示例的图片地址\`http://placehold.it/150x100\`

图片加载失败的效果：
![图片加载失败的文案](http://xxx.com "悬浮提示文案")

## 列表

### 有序列表
\`\`\`
1. 第一行
2. 第二行
3. 第三行
\`\`\`

效果：
1. 第一行
2. 第二行
3. 第三行

### 无序列表
\`\`\`
- 第一行
- 第二行
- 第三行
\`\`\`

效果：
- 第一行
- 第二行
- 第三行


## 列表嵌套

\`\`\`
1. 第一行
2. 第二行
    1. 第二行第一行
    2. 第二行第二行
\`\`\`

1. 第一行
2. 第二行
    1. 第二行第一行
    2. 第二行第二行

### 无序嵌套

\`\`\`
- 第一行
- 第二行
    - 第二行第一行
    - 第二行第二行
\`\`\`

- 第一行
- 第二行
    - 第二行第一行
    - 第二行第二行

## 其他：
需要有段落，请使用两个换行符(两个回车)。
`;
